// extracted by mini-css-extract-plugin
export default {"wrap":"mA-z","logoContainer":"nA-z","brandImg":"oA-z","logoImg":"pA-z","logoButton":"qA-z"};